/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigator APP
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 1.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { BooleanResponse } from '../models';
import { InvestigationAccountingAppViewIEnumerableResponse } from '../models';
import { InvestigationBreachViewIEnumerableResponse } from '../models';
import { InvestigationFileViewResponse } from '../models';
import { InvestigationMaintainFileRequest } from '../models';
import { InvestigationMaintainFileViewIEnumerableResponse } from '../models';
import { InvestigationOverdrawnLedgerViewIEnumerableResponse } from '../models';
import { InvestigationOverdrawnRequest } from '../models';
import { InvestigationParameterRequest } from '../models';
import { InvestigationParameterViewResponse } from '../models';
import { InvestigationViewIEnumerableResponse } from '../models';
import { InvestigationViewResponse } from '../models';
import { InvestigationViewResponseFinaliseError } from '../models';
import { InvestigationWithQuestionnaireViewResponse } from '../models';
import { InvestigatorWorkingPaperFileRequest } from '../models';
import { InvestigatorWorkingPaperRequest } from '../models';
import { InvestigatorWorkingPaperViewIEnumerableResponse } from '../models';
import { IwpFileStreamRequest } from '../models';
import { PrincipalInformationRequest } from '../models';
import { QuestionnaireView } from '../models';
import { SectionGroupView } from '../models';
import { SectionView } from '../models';
import { TrustTeamMemberInvestigationFilterRequest } from '../models';
/**
 * InvestigationApi - axios parameter creator
 * @export
 */
export const InvestigationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationDeleteInvestigationMaintainFileIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling apiV1InvestigationDeleteInvestigationMaintainFileIdDelete.');
            }
            const localVarPath = `/api/v1/Investigation/DeleteInvestigationMaintainFile/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationDeleteInvestigationOverdrawnLedgerIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling apiV1InvestigationDeleteInvestigationOverdrawnLedgerIdDelete.');
            }
            const localVarPath = `/api/v1/Investigation/DeleteInvestigationOverdrawnLedger/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} investigationFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationDeleteInvestigatorWorkingPaperFileInvestigationFileIdDelete: async (investigationFileId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationFileId' is not null or undefined
            if (investigationFileId === null || investigationFileId === undefined) {
                throw new RequiredError('investigationFileId','Required parameter investigationFileId was null or undefined when calling apiV1InvestigationDeleteInvestigatorWorkingPaperFileInvestigationFileIdDelete.');
            }
            const localVarPath = `/api/v1/Investigation/DeleteInvestigatorWorkingPaperFile/{investigationFileId}`
                .replace(`{${"investigationFileId"}}`, encodeURIComponent(String(investigationFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationDeleteInvestigatorWorkingPaperIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling apiV1InvestigationDeleteInvestigatorWorkingPaperIdDelete.');
            }
            const localVarPath = `/api/v1/Investigation/DeleteInvestigatorWorkingPaper/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InvestigatorWorkingPaperRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationEditInvestigatorWorkingPaperPost: async (body?: InvestigatorWorkingPaperRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Investigation/EditInvestigatorWorkingPaper`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationFinaliseInvestigationInvestigationIdGet: async (investigationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV1InvestigationFinaliseInvestigationInvestigationIdGet.');
            }
            const localVarPath = `/api/v1/Investigation/FinaliseInvestigation/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} investigatorWorkingPaperId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationGetFileByInvestigatorWorkingPaperIdInvestigatorWorkingPaperIdGet: async (investigatorWorkingPaperId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigatorWorkingPaperId' is not null or undefined
            if (investigatorWorkingPaperId === null || investigatorWorkingPaperId === undefined) {
                throw new RequiredError('investigatorWorkingPaperId','Required parameter investigatorWorkingPaperId was null or undefined when calling apiV1InvestigationGetFileByInvestigatorWorkingPaperIdInvestigatorWorkingPaperIdGet.');
            }
            const localVarPath = `/api/v1/Investigation/GetFileByInvestigatorWorkingPaperId/{investigatorWorkingPaperId}`
                .replace(`{${"investigatorWorkingPaperId"}}`, encodeURIComponent(String(investigatorWorkingPaperId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} investigatorWorkingPaperId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationGetFileStreamByInvestigatorWorkingPaperIdInvestigatorWorkingPaperIdGet: async (investigatorWorkingPaperId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigatorWorkingPaperId' is not null or undefined
            if (investigatorWorkingPaperId === null || investigatorWorkingPaperId === undefined) {
                throw new RequiredError('investigatorWorkingPaperId','Required parameter investigatorWorkingPaperId was null or undefined when calling apiV1InvestigationGetFileStreamByInvestigatorWorkingPaperIdInvestigatorWorkingPaperIdGet.');
            }
            const localVarPath = `/api/v1/Investigation/GetFileStreamByInvestigatorWorkingPaperId/{investigatorWorkingPaperId}`
                .replace(`{${"investigatorWorkingPaperId"}}`, encodeURIComponent(String(investigatorWorkingPaperId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationGetInvestigationAccountingDetailsByPracticeIdPracticeIdGet: async (practiceId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV1InvestigationGetInvestigationAccountingDetailsByPracticeIdPracticeIdGet.');
            }
            const localVarPath = `/api/v1/Investigation/GetInvestigationAccountingDetailsByPracticeId/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationGetInvestigationBreachesByIdInvestigationIdGet: async (investigationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV1InvestigationGetInvestigationBreachesByIdInvestigationIdGet.');
            }
            const localVarPath = `/api/v1/Investigation/GetInvestigationBreachesById/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationGetInvestigationByInvestigationIdInvestigationIdGet: async (investigationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV1InvestigationGetInvestigationByInvestigationIdInvestigationIdGet.');
            }
            const localVarPath = `/api/v1/Investigation/GetInvestigationByInvestigationId/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationGetInvestigationMaintainFilesInvestigationIdGet: async (investigationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV1InvestigationGetInvestigationMaintainFilesInvestigationIdGet.');
            }
            const localVarPath = `/api/v1/Investigation/GetInvestigationMaintainFiles/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationGetInvestigationOverdrawnLedgersByInvestigationIdInvestigationIdGet: async (investigationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV1InvestigationGetInvestigationOverdrawnLedgersByInvestigationIdInvestigationIdGet.');
            }
            const localVarPath = `/api/v1/Investigation/GetInvestigationOverdrawnLedgersByInvestigationId/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationGetInvestigationParametersInvestigationIdGet: async (investigationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV1InvestigationGetInvestigationParametersInvestigationIdGet.');
            }
            const localVarPath = `/api/v1/Investigation/GetInvestigationParameters/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationGetInvestigationWithQuestionnaireByIdIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling apiV1InvestigationGetInvestigationWithQuestionnaireByIdIdGet.');
            }
            const localVarPath = `/api/v1/Investigation/GetInvestigationWithQuestionnaireById/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationGetInvestigationsByPracticeIdPracticeIdGet: async (practiceId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV1InvestigationGetInvestigationsByPracticeIdPracticeIdGet.');
            }
            const localVarPath = `/api/v1/Investigation/GetInvestigationsByPracticeId/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TrustTeamMemberInvestigationFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationGetInvestigationsByTrustTeamMemberIdPost: async (body?: TrustTeamMemberInvestigationFilterRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Investigation/GetInvestigationsByTrustTeamMemberId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationGetInvestigationsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Investigation/GetInvestigations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationGetInvestigatorWorkingPapersByInvestigationIdInvestigationIdGet: async (investigationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV1InvestigationGetInvestigatorWorkingPapersByInvestigationIdInvestigationIdGet.');
            }
            const localVarPath = `/api/v1/Investigation/GetInvestigatorWorkingPapersByInvestigationId/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {IwpFileStreamRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationGetIwpFileStreamPost: async (body?: IwpFileStreamRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Investigation/GetIwpFileStream`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationGetIwpsByInvestigationIdInvestigationIdGet: async (investigationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV1InvestigationGetIwpsByInvestigationIdInvestigationIdGet.');
            }
            const localVarPath = `/api/v1/Investigation/GetIwpsByInvestigationId/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InvestigationMaintainFileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationSaveInvestigationMaintainFilePost: async (body?: InvestigationMaintainFileRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Investigation/SaveInvestigationMaintainFile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InvestigationOverdrawnRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationSaveInvestigationOverdrawnLedgerPost: async (body?: InvestigationOverdrawnRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Investigation/SaveInvestigationOverdrawnLedger`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InvestigationParameterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationSaveInvestigationParametersPost: async (body?: InvestigationParameterRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Investigation/SaveInvestigationParameters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InvestigatorWorkingPaperFileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationSaveInvestigatorWorkingPaperFilePost: async (body?: InvestigatorWorkingPaperFileRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Investigation/SaveInvestigatorWorkingPaperFile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InvestigatorWorkingPaperRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationSaveInvestigatorWorkingPaperPost: async (body?: InvestigatorWorkingPaperRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Investigation/SaveInvestigatorWorkingPaper`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PrincipalInformationRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationSavePrincipalInformationPost: async (body?: PrincipalInformationRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Investigation/SavePrincipalInformation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SectionView} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationSaveQuestionSectionPost: async (body?: SectionView, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Investigation/SaveQuestionSection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {QuestionnaireView} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationSaveQuestionnairePost: async (body?: QuestionnaireView, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Investigation/SaveQuestionnaire`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SectionGroupView} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationSaveSectionGroupOverviewPost: async (body?: SectionGroupView, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Investigation/SaveSectionGroupOverview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvestigationApi - functional programming interface
 * @export
 */
export const InvestigationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvestigationDeleteInvestigationMaintainFileIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV1InvestigationDeleteInvestigationMaintainFileIdDelete(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvestigationDeleteInvestigationOverdrawnLedgerIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV1InvestigationDeleteInvestigationOverdrawnLedgerIdDelete(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} investigationFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvestigationDeleteInvestigatorWorkingPaperFileInvestigationFileIdDelete(investigationFileId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV1InvestigationDeleteInvestigatorWorkingPaperFileInvestigationFileIdDelete(investigationFileId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvestigationDeleteInvestigatorWorkingPaperIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV1InvestigationDeleteInvestigatorWorkingPaperIdDelete(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {InvestigatorWorkingPaperRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvestigationEditInvestigatorWorkingPaperPost(body?: InvestigatorWorkingPaperRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV1InvestigationEditInvestigatorWorkingPaperPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvestigationFinaliseInvestigationInvestigationIdGet(investigationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationViewResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV1InvestigationFinaliseInvestigationInvestigationIdGet(investigationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} investigatorWorkingPaperId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvestigationGetFileByInvestigatorWorkingPaperIdInvestigatorWorkingPaperIdGet(investigatorWorkingPaperId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationFileViewResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV1InvestigationGetFileByInvestigatorWorkingPaperIdInvestigatorWorkingPaperIdGet(investigatorWorkingPaperId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} investigatorWorkingPaperId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvestigationGetFileStreamByInvestigatorWorkingPaperIdInvestigatorWorkingPaperIdGet(investigatorWorkingPaperId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV1InvestigationGetFileStreamByInvestigatorWorkingPaperIdInvestigatorWorkingPaperIdGet(investigatorWorkingPaperId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvestigationGetInvestigationAccountingDetailsByPracticeIdPracticeIdGet(practiceId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationAccountingAppViewIEnumerableResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV1InvestigationGetInvestigationAccountingDetailsByPracticeIdPracticeIdGet(practiceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvestigationGetInvestigationBreachesByIdInvestigationIdGet(investigationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationBreachViewIEnumerableResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV1InvestigationGetInvestigationBreachesByIdInvestigationIdGet(investigationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvestigationGetInvestigationByInvestigationIdInvestigationIdGet(investigationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationViewResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV1InvestigationGetInvestigationByInvestigationIdInvestigationIdGet(investigationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvestigationGetInvestigationMaintainFilesInvestigationIdGet(investigationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationMaintainFileViewIEnumerableResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV1InvestigationGetInvestigationMaintainFilesInvestigationIdGet(investigationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvestigationGetInvestigationOverdrawnLedgersByInvestigationIdInvestigationIdGet(investigationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationOverdrawnLedgerViewIEnumerableResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV1InvestigationGetInvestigationOverdrawnLedgersByInvestigationIdInvestigationIdGet(investigationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvestigationGetInvestigationParametersInvestigationIdGet(investigationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationParameterViewResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV1InvestigationGetInvestigationParametersInvestigationIdGet(investigationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvestigationGetInvestigationWithQuestionnaireByIdIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationWithQuestionnaireViewResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV1InvestigationGetInvestigationWithQuestionnaireByIdIdGet(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvestigationGetInvestigationsByPracticeIdPracticeIdGet(practiceId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationViewIEnumerableResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV1InvestigationGetInvestigationsByPracticeIdPracticeIdGet(practiceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {TrustTeamMemberInvestigationFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvestigationGetInvestigationsByTrustTeamMemberIdPost(body?: TrustTeamMemberInvestigationFilterRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationViewIEnumerableResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV1InvestigationGetInvestigationsByTrustTeamMemberIdPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvestigationGetInvestigationsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationViewIEnumerableResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV1InvestigationGetInvestigationsGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvestigationGetInvestigatorWorkingPapersByInvestigationIdInvestigationIdGet(investigationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigatorWorkingPaperViewIEnumerableResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV1InvestigationGetInvestigatorWorkingPapersByInvestigationIdInvestigationIdGet(investigationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {IwpFileStreamRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvestigationGetIwpFileStreamPost(body?: IwpFileStreamRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV1InvestigationGetIwpFileStreamPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvestigationGetIwpsByInvestigationIdInvestigationIdGet(investigationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigatorWorkingPaperViewIEnumerableResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV1InvestigationGetIwpsByInvestigationIdInvestigationIdGet(investigationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {InvestigationMaintainFileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvestigationSaveInvestigationMaintainFilePost(body?: InvestigationMaintainFileRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV1InvestigationSaveInvestigationMaintainFilePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {InvestigationOverdrawnRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvestigationSaveInvestigationOverdrawnLedgerPost(body?: InvestigationOverdrawnRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV1InvestigationSaveInvestigationOverdrawnLedgerPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {InvestigationParameterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvestigationSaveInvestigationParametersPost(body?: InvestigationParameterRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV1InvestigationSaveInvestigationParametersPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {InvestigatorWorkingPaperFileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvestigationSaveInvestigatorWorkingPaperFilePost(body?: InvestigatorWorkingPaperFileRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV1InvestigationSaveInvestigatorWorkingPaperFilePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {InvestigatorWorkingPaperRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvestigationSaveInvestigatorWorkingPaperPost(body?: InvestigatorWorkingPaperRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV1InvestigationSaveInvestigatorWorkingPaperPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {PrincipalInformationRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvestigationSavePrincipalInformationPost(body?: PrincipalInformationRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV1InvestigationSavePrincipalInformationPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {SectionView} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvestigationSaveQuestionSectionPost(body?: SectionView, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV1InvestigationSaveQuestionSectionPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {QuestionnaireView} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvestigationSaveQuestionnairePost(body?: QuestionnaireView, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV1InvestigationSaveQuestionnairePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {SectionGroupView} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvestigationSaveSectionGroupOverviewPost(body?: SectionGroupView, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV1InvestigationSaveSectionGroupOverviewPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * InvestigationApi - factory interface
 * @export
 */
export const InvestigationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationDeleteInvestigationMaintainFileIdDelete(id: number, options?: any): AxiosPromise<BooleanResponse> {
            return InvestigationApiFp(configuration).apiV1InvestigationDeleteInvestigationMaintainFileIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationDeleteInvestigationOverdrawnLedgerIdDelete(id: number, options?: any): AxiosPromise<BooleanResponse> {
            return InvestigationApiFp(configuration).apiV1InvestigationDeleteInvestigationOverdrawnLedgerIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} investigationFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationDeleteInvestigatorWorkingPaperFileInvestigationFileIdDelete(investigationFileId: string, options?: any): AxiosPromise<BooleanResponse> {
            return InvestigationApiFp(configuration).apiV1InvestigationDeleteInvestigatorWorkingPaperFileInvestigationFileIdDelete(investigationFileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationDeleteInvestigatorWorkingPaperIdDelete(id: number, options?: any): AxiosPromise<BooleanResponse> {
            return InvestigationApiFp(configuration).apiV1InvestigationDeleteInvestigatorWorkingPaperIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvestigatorWorkingPaperRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationEditInvestigatorWorkingPaperPost(body?: InvestigatorWorkingPaperRequest, options?: any): AxiosPromise<BooleanResponse> {
            return InvestigationApiFp(configuration).apiV1InvestigationEditInvestigatorWorkingPaperPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationFinaliseInvestigationInvestigationIdGet(investigationId: number, options?: any): AxiosPromise<InvestigationViewResponse> {
            return InvestigationApiFp(configuration).apiV1InvestigationFinaliseInvestigationInvestigationIdGet(investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} investigatorWorkingPaperId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationGetFileByInvestigatorWorkingPaperIdInvestigatorWorkingPaperIdGet(investigatorWorkingPaperId: number, options?: any): AxiosPromise<InvestigationFileViewResponse> {
            return InvestigationApiFp(configuration).apiV1InvestigationGetFileByInvestigatorWorkingPaperIdInvestigatorWorkingPaperIdGet(investigatorWorkingPaperId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} investigatorWorkingPaperId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationGetFileStreamByInvestigatorWorkingPaperIdInvestigatorWorkingPaperIdGet(investigatorWorkingPaperId: number, options?: any): AxiosPromise<string> {
            return InvestigationApiFp(configuration).apiV1InvestigationGetFileStreamByInvestigatorWorkingPaperIdInvestigatorWorkingPaperIdGet(investigatorWorkingPaperId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationGetInvestigationAccountingDetailsByPracticeIdPracticeIdGet(practiceId: number, options?: any): AxiosPromise<InvestigationAccountingAppViewIEnumerableResponse> {
            return InvestigationApiFp(configuration).apiV1InvestigationGetInvestigationAccountingDetailsByPracticeIdPracticeIdGet(practiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationGetInvestigationBreachesByIdInvestigationIdGet(investigationId: number, options?: any): AxiosPromise<InvestigationBreachViewIEnumerableResponse> {
            return InvestigationApiFp(configuration).apiV1InvestigationGetInvestigationBreachesByIdInvestigationIdGet(investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationGetInvestigationByInvestigationIdInvestigationIdGet(investigationId: number, options?: any): AxiosPromise<InvestigationViewResponse> {
            return InvestigationApiFp(configuration).apiV1InvestigationGetInvestigationByInvestigationIdInvestigationIdGet(investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationGetInvestigationMaintainFilesInvestigationIdGet(investigationId: number, options?: any): AxiosPromise<InvestigationMaintainFileViewIEnumerableResponse> {
            return InvestigationApiFp(configuration).apiV1InvestigationGetInvestigationMaintainFilesInvestigationIdGet(investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationGetInvestigationOverdrawnLedgersByInvestigationIdInvestigationIdGet(investigationId: number, options?: any): AxiosPromise<InvestigationOverdrawnLedgerViewIEnumerableResponse> {
            return InvestigationApiFp(configuration).apiV1InvestigationGetInvestigationOverdrawnLedgersByInvestigationIdInvestigationIdGet(investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationGetInvestigationParametersInvestigationIdGet(investigationId: number, options?: any): AxiosPromise<InvestigationParameterViewResponse> {
            return InvestigationApiFp(configuration).apiV1InvestigationGetInvestigationParametersInvestigationIdGet(investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationGetInvestigationWithQuestionnaireByIdIdGet(id: number, options?: any): AxiosPromise<InvestigationWithQuestionnaireViewResponse> {
            return InvestigationApiFp(configuration).apiV1InvestigationGetInvestigationWithQuestionnaireByIdIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationGetInvestigationsByPracticeIdPracticeIdGet(practiceId: number, options?: any): AxiosPromise<InvestigationViewIEnumerableResponse> {
            return InvestigationApiFp(configuration).apiV1InvestigationGetInvestigationsByPracticeIdPracticeIdGet(practiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TrustTeamMemberInvestigationFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationGetInvestigationsByTrustTeamMemberIdPost(body?: TrustTeamMemberInvestigationFilterRequest, options?: any): AxiosPromise<InvestigationViewIEnumerableResponse> {
            return InvestigationApiFp(configuration).apiV1InvestigationGetInvestigationsByTrustTeamMemberIdPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationGetInvestigationsGet(options?: any): AxiosPromise<InvestigationViewIEnumerableResponse> {
            return InvestigationApiFp(configuration).apiV1InvestigationGetInvestigationsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationGetInvestigatorWorkingPapersByInvestigationIdInvestigationIdGet(investigationId: number, options?: any): AxiosPromise<InvestigatorWorkingPaperViewIEnumerableResponse> {
            return InvestigationApiFp(configuration).apiV1InvestigationGetInvestigatorWorkingPapersByInvestigationIdInvestigationIdGet(investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IwpFileStreamRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationGetIwpFileStreamPost(body?: IwpFileStreamRequest, options?: any): AxiosPromise<string> {
            return InvestigationApiFp(configuration).apiV1InvestigationGetIwpFileStreamPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationGetIwpsByInvestigationIdInvestigationIdGet(investigationId: number, options?: any): AxiosPromise<InvestigatorWorkingPaperViewIEnumerableResponse> {
            return InvestigationApiFp(configuration).apiV1InvestigationGetIwpsByInvestigationIdInvestigationIdGet(investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvestigationMaintainFileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationSaveInvestigationMaintainFilePost(body?: InvestigationMaintainFileRequest, options?: any): AxiosPromise<BooleanResponse> {
            return InvestigationApiFp(configuration).apiV1InvestigationSaveInvestigationMaintainFilePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvestigationOverdrawnRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationSaveInvestigationOverdrawnLedgerPost(body?: InvestigationOverdrawnRequest, options?: any): AxiosPromise<BooleanResponse> {
            return InvestigationApiFp(configuration).apiV1InvestigationSaveInvestigationOverdrawnLedgerPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvestigationParameterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationSaveInvestigationParametersPost(body?: InvestigationParameterRequest, options?: any): AxiosPromise<BooleanResponse> {
            return InvestigationApiFp(configuration).apiV1InvestigationSaveInvestigationParametersPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvestigatorWorkingPaperFileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationSaveInvestigatorWorkingPaperFilePost(body?: InvestigatorWorkingPaperFileRequest, options?: any): AxiosPromise<BooleanResponse> {
            return InvestigationApiFp(configuration).apiV1InvestigationSaveInvestigatorWorkingPaperFilePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvestigatorWorkingPaperRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationSaveInvestigatorWorkingPaperPost(body?: InvestigatorWorkingPaperRequest, options?: any): AxiosPromise<BooleanResponse> {
            return InvestigationApiFp(configuration).apiV1InvestigationSaveInvestigatorWorkingPaperPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PrincipalInformationRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationSavePrincipalInformationPost(body?: PrincipalInformationRequest, options?: any): AxiosPromise<BooleanResponse> {
            return InvestigationApiFp(configuration).apiV1InvestigationSavePrincipalInformationPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SectionView} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationSaveQuestionSectionPost(body?: SectionView, options?: any): AxiosPromise<BooleanResponse> {
            return InvestigationApiFp(configuration).apiV1InvestigationSaveQuestionSectionPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionnaireView} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationSaveQuestionnairePost(body?: QuestionnaireView, options?: any): AxiosPromise<BooleanResponse> {
            return InvestigationApiFp(configuration).apiV1InvestigationSaveQuestionnairePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SectionGroupView} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvestigationSaveSectionGroupOverviewPost(body?: SectionGroupView, options?: any): AxiosPromise<BooleanResponse> {
            return InvestigationApiFp(configuration).apiV1InvestigationSaveSectionGroupOverviewPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InvestigationApi - object-oriented interface
 * @export
 * @class InvestigationApi
 * @extends {BaseAPI}
 */
export class InvestigationApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV1InvestigationDeleteInvestigationMaintainFileIdDelete(id: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV1InvestigationDeleteInvestigationMaintainFileIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV1InvestigationDeleteInvestigationOverdrawnLedgerIdDelete(id: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV1InvestigationDeleteInvestigationOverdrawnLedgerIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} investigationFileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV1InvestigationDeleteInvestigatorWorkingPaperFileInvestigationFileIdDelete(investigationFileId: string, options?: any) {
        return InvestigationApiFp(this.configuration).apiV1InvestigationDeleteInvestigatorWorkingPaperFileInvestigationFileIdDelete(investigationFileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV1InvestigationDeleteInvestigatorWorkingPaperIdDelete(id: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV1InvestigationDeleteInvestigatorWorkingPaperIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {InvestigatorWorkingPaperRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV1InvestigationEditInvestigatorWorkingPaperPost(body?: InvestigatorWorkingPaperRequest, options?: any) {
        return InvestigationApiFp(this.configuration).apiV1InvestigationEditInvestigatorWorkingPaperPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} investigationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV1InvestigationFinaliseInvestigationInvestigationIdGet(investigationId: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV1InvestigationFinaliseInvestigationInvestigationIdGet(investigationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} investigatorWorkingPaperId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV1InvestigationGetFileByInvestigatorWorkingPaperIdInvestigatorWorkingPaperIdGet(investigatorWorkingPaperId: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV1InvestigationGetFileByInvestigatorWorkingPaperIdInvestigatorWorkingPaperIdGet(investigatorWorkingPaperId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} investigatorWorkingPaperId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV1InvestigationGetFileStreamByInvestigatorWorkingPaperIdInvestigatorWorkingPaperIdGet(investigatorWorkingPaperId: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV1InvestigationGetFileStreamByInvestigatorWorkingPaperIdInvestigatorWorkingPaperIdGet(investigatorWorkingPaperId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} practiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV1InvestigationGetInvestigationAccountingDetailsByPracticeIdPracticeIdGet(practiceId: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV1InvestigationGetInvestigationAccountingDetailsByPracticeIdPracticeIdGet(practiceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} investigationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV1InvestigationGetInvestigationBreachesByIdInvestigationIdGet(investigationId: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV1InvestigationGetInvestigationBreachesByIdInvestigationIdGet(investigationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} investigationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV1InvestigationGetInvestigationByInvestigationIdInvestigationIdGet(investigationId: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV1InvestigationGetInvestigationByInvestigationIdInvestigationIdGet(investigationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} investigationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV1InvestigationGetInvestigationMaintainFilesInvestigationIdGet(investigationId: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV1InvestigationGetInvestigationMaintainFilesInvestigationIdGet(investigationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} investigationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV1InvestigationGetInvestigationOverdrawnLedgersByInvestigationIdInvestigationIdGet(investigationId: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV1InvestigationGetInvestigationOverdrawnLedgersByInvestigationIdInvestigationIdGet(investigationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} investigationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV1InvestigationGetInvestigationParametersInvestigationIdGet(investigationId: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV1InvestigationGetInvestigationParametersInvestigationIdGet(investigationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV1InvestigationGetInvestigationWithQuestionnaireByIdIdGet(id: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV1InvestigationGetInvestigationWithQuestionnaireByIdIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} practiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV1InvestigationGetInvestigationsByPracticeIdPracticeIdGet(practiceId: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV1InvestigationGetInvestigationsByPracticeIdPracticeIdGet(practiceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {TrustTeamMemberInvestigationFilterRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV1InvestigationGetInvestigationsByTrustTeamMemberIdPost(body?: TrustTeamMemberInvestigationFilterRequest, options?: any) {
        return InvestigationApiFp(this.configuration).apiV1InvestigationGetInvestigationsByTrustTeamMemberIdPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV1InvestigationGetInvestigationsGet(options?: any) {
        return InvestigationApiFp(this.configuration).apiV1InvestigationGetInvestigationsGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} investigationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV1InvestigationGetInvestigatorWorkingPapersByInvestigationIdInvestigationIdGet(investigationId: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV1InvestigationGetInvestigatorWorkingPapersByInvestigationIdInvestigationIdGet(investigationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {IwpFileStreamRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV1InvestigationGetIwpFileStreamPost(body?: IwpFileStreamRequest, options?: any) {
        return InvestigationApiFp(this.configuration).apiV1InvestigationGetIwpFileStreamPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} investigationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV1InvestigationGetIwpsByInvestigationIdInvestigationIdGet(investigationId: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV1InvestigationGetIwpsByInvestigationIdInvestigationIdGet(investigationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {InvestigationMaintainFileRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV1InvestigationSaveInvestigationMaintainFilePost(body?: InvestigationMaintainFileRequest, options?: any) {
        return InvestigationApiFp(this.configuration).apiV1InvestigationSaveInvestigationMaintainFilePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {InvestigationOverdrawnRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV1InvestigationSaveInvestigationOverdrawnLedgerPost(body?: InvestigationOverdrawnRequest, options?: any) {
        return InvestigationApiFp(this.configuration).apiV1InvestigationSaveInvestigationOverdrawnLedgerPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {InvestigationParameterRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV1InvestigationSaveInvestigationParametersPost(body?: InvestigationParameterRequest, options?: any) {
        return InvestigationApiFp(this.configuration).apiV1InvestigationSaveInvestigationParametersPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {InvestigatorWorkingPaperFileRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV1InvestigationSaveInvestigatorWorkingPaperFilePost(body?: InvestigatorWorkingPaperFileRequest, options?: any) {
        return InvestigationApiFp(this.configuration).apiV1InvestigationSaveInvestigatorWorkingPaperFilePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {InvestigatorWorkingPaperRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV1InvestigationSaveInvestigatorWorkingPaperPost(body?: InvestigatorWorkingPaperRequest, options?: any) {
        return InvestigationApiFp(this.configuration).apiV1InvestigationSaveInvestigatorWorkingPaperPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {PrincipalInformationRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV1InvestigationSavePrincipalInformationPost(body?: PrincipalInformationRequest, options?: any) {
        return InvestigationApiFp(this.configuration).apiV1InvestigationSavePrincipalInformationPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {SectionView} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV1InvestigationSaveQuestionSectionPost(body?: SectionView, options?: any) {
        return InvestigationApiFp(this.configuration).apiV1InvestigationSaveQuestionSectionPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {QuestionnaireView} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV1InvestigationSaveQuestionnairePost(body?: QuestionnaireView, options?: any) {
        return InvestigationApiFp(this.configuration).apiV1InvestigationSaveQuestionnairePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {SectionGroupView} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV1InvestigationSaveSectionGroupOverviewPost(body?: SectionGroupView, options?: any) {
        return InvestigationApiFp(this.configuration).apiV1InvestigationSaveSectionGroupOverviewPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
